import { render, staticRenderFns } from "./Service1Table.vue?vue&type=template&id=3c642587&"
import script from "./Service1Table.vue?vue&type=script&lang=js&"
export * from "./Service1Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports